import { z } from "zod";

const translationPath =
  "chatBot.page.automations.automationReceivedRules.automationReceivedRuleCancelationReason.errors.";

const cancelationReasonSchema = z.object(
  {
    id: z.string(),
    name: z.string(),
    code: z.string().nullish(),
  },
  { invalid_type_error: translationPath + "cancelation_reason_field" },
);

export const cancelationReasonsSchema = z.object({
  id: z.string().optional(),
  cancelationReason: cancelationReasonSchema,
});

export type TCancelationReasonsForm = z.infer<typeof cancelationReasonsSchema>;
